import { NavGroup } from '@susu/headless-commerce/features/navigation/components/NavGroup'
import type { Navigation } from '@susu/headless-commerce/features/navigation/domain'
import { generateIdentifier } from '@susu/size-selector/utils/identifier'
import classNames from 'classnames'
import styles from './NavLinks.module.scss'

export type NavLinksProps = {
  className?: string
  isSubMenu?: boolean
  navigation: Navigation
}

export const NavLinks = ({
  className,
  isSubMenu = false,
  navigation,
}: NavLinksProps) => {
  const linksClass = classNames(
    {
      [`${styles['nav__links']} nav__links`]: !isSubMenu,
      [`${styles['nav__submenu-links']} nav__submenu-links`]: isSubMenu,
    },
    className,
  )

  return (
    <div className={linksClass} data-testid="nav-links">
      {navigation.groups?.map((group) => {
        return (
          <NavGroup
            group={group}
            isSubMenu={isSubMenu}
            key={generateIdentifier()}
          />
        )
      })}
    </div>
  )
}
